import c from "../common";

export default {
  //Column
  Time: "時間",
  status: c.status.chn,
  paid: "已付款",
  currency: "貨幣",
  vendorName: c.vendor.chn + "名",
  assistant: c.assistant.chn,
  consumer: c.consumer.chn,
  totalAmount: "總金額(CAD)",
  paymentGateway: "付款渠道",
  atStore: "門店付款",
  onApp: "在應用程式外購買",
  reference: "付款參考編號",

  totalQty: "兌換總數",
  qty: "張數",
  voucherName: c.voucher.chn + "名稱",
  voucherId: c.voucher.chn + "編號",
  price: "金額(CAD)",

  staffId: c.assistant.chn,
  consumerEmail: c.consumer.chn + "電郵",
  consumerFullName: c.consumer.chn + "名稱",
  consumerTel: c.consumer.chn + "電話",

  download: c.download.chn,
};
